<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead"><span class="bold">Contents</span></h2>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryNumber"><a href="#/ch01#ch01">One</a>
<br/>If you look inside my refrigerator, here’s what you’ll see:…
</p></div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryNumber"><a href="#/ch02#ch02">Two</a>
<br/>About my job.
</p></div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryNumber"><a href="#/ch03#ch03">Three</a>
<br/>Because every time I think of my mother-in-law I want…
</p></div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryNumber"><span href="#/ch04#ch04" title="Link target outside of Sample">Four</span>
<br/>I’m at my kitchen table pounding the keys on my…
</p></div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryNumber"><span href="#/ch05#ch05" title="Link target outside of Sample">Five</span>
<br/>I’m getting ready for work. A quick shower, clean underwear,…
</p></div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryNumber"><span href="#/ch06#ch06" title="Link target outside of Sample">Six</span>
<br/>I pull up in front of Seamus O’Toole’s house. A…
</p></div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryNumber"><span href="#/ch07#ch07" title="Link target outside of Sample">Seven</span>
<br/>This morning I’m at the kitchen table reading the New…
</p></div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryNumber"><span href="#/ch08#ch08" title="Link target outside of Sample">Eight</span>
<br/>Tommy calls to tell me he’ll be home late in…
</p></div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryNumber"><span href="#/ch09#ch09" title="Link target outside of Sample">Nine</span>
<br/>I drive to Jeremy Marshall’s condo and leave the Baggie…
</p></div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryNumber"><span href="#/ch10#ch10" title="Link target outside of Sample">Ten</span>
<br/>The phone rings. I jolt awake. The images in my…
</p></div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryNumber"><span href="#/ch11#ch11" title="Link target outside of Sample">Eleven</span>
<br/>At five o’clock, the sky darkens. Rain pounds with the…
</p></div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryNumber"><span href="#/ch12#ch12" title="Link target outside of Sample">Twelve</span>
<br/>My horoscope this morning warns of gray skies ahead, even…
</p></div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryNumber"><span href="#/ch13#ch13" title="Link target outside of Sample">Thirteen</span>
<br/>By the time I get home, the skies have turned…
</p></div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryNumber"><span href="#/ch14#ch14" title="Link target outside of Sample">Fourteen</span>
<br/>The meeting over the custody of Anthony Vincent is planned…
</p></div>
<div class="contentsEntry" id="ch_15">
<p class="contentsEntryNumber"><span href="#/ch15#ch15" title="Link target outside of Sample">Fifteen</span>
<br/>The conference room, which resembles the teachers’ lounge of a…
</p></div>
<div class="contentsEntry" id="ch_16">
<p class="contentsEntryNumber"><span href="#/ch16#ch16" title="Link target outside of Sample">Sixteen</span>
<br/>On the way to Gabriel’s house, I stop at the…
</p></div>
<div class="contentsEntry" id="ch_17">
<p class="contentsEntryNumber"><span href="#/ch17#ch17" title="Link target outside of Sample">Seventeen</span>
<br/>Tommy, September, and I are having breakfast together this morning,…
</p></div>
<div class="contentsEntry" id="ch_18">
<p class="contentsEntryNumber"><span href="#/ch18#ch18" title="Link target outside of Sample">Eighteen</span>
<br/>I’ve come home early, leaving Darlene in the progressively frailer…
</p></div>
<div class="contentsEntry" id="ch_19">
<p class="contentsEntryNumber"><span href="#/ch19#ch19" title="Link target outside of Sample">Nineteen</span>
<br/>It’s two weeks after Labor Day. Tommy and September are…
</p></div>
<br/>
<div class="contentsEntry1" id="ack_01">
<p class="contentsEntryName"><span href="#/ack01#ack01" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
<div class="contentsEntry1" id="ata_01">
<p class="contentsEntryName"><span href="#/ata01#ata01" title="Link target outside of Sample">About the Author</span></p>
</div>
<div class="contentsEntry1" id="adc_01">
<p class="contentsEntryName"><span href="#/adc01#adc01" title="Link target outside of Sample">Other Books by Mameve Medwed</span></p>
</div>
<div class="contentsEntry1" id="cre_01">
<p class="contentsEntryName"><span href="#/cre01#cre01" title="Link target outside of Sample">Credits</span></p>
</div>
<div class="contentsEntry1" id="cop_01">
<p class="contentsEntryName"><span href="#/cop01#cop01" title="Link target outside of Sample">Copyright</span></p>
</div>
<div class="contentsEntry1" id="atp_01">
<p class="contentsEntryName"><span href="#/atp01#atp01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?62177e96